import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69a29fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "currentShape-type__buttons" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "currentShape-type__list"
}
const _hoisted_6 = {
  key: 1,
  class: "currentShape-type__list"
}
const _hoisted_7 = {
  key: 0,
  class: "editable-list"
}
const _hoisted_8 = { class: "editable-list__item editable-list__item--active" }

import { useStore } from "vuex";
import { computed, ref } from "vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";
import TextLabel from "@/components/UI/TextLabel.vue";
import EditableItem from './EditableItem.vue';
import MeasurementsHeightTransition from '@/components/UI/MeasurementsHeightTransition.vue';
import { AbstractPreset } from "@/presets/AbstractPreset";

export interface Props {
	disabledShapes?: string[];
	storeShapeGetter?: string;
	storeShapeUpdater?: string;
	action?: string;
	prefix?: string;
	isCutout?: boolean;
	modifierAction?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeType',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const i18n = window.measurementSelectorVariables.i18n;
const store = useStore();
const props = __props;
const type = ref('straight');

const presetShape = computed(() => store.getters.presetShape);
const currentShape = computed(() => {
	if (!props.storeShapeGetter) return;

	// We don't have presets for cutouts so we don't need to check for them
	if (props.isCutout) return store.getters[props.storeShapeGetter];

	if (presetShape.value) {
		setCategory('preset');
		return presetShape.value;
	}

	return store.getters[props.storeShapeGetter];
});
const presets = computed(() => store.getters.getPresets );
const shapeName = computed(() => store.getters.getShapeName );

const categorizedShapes = computed(() => {
	const enabledShapes = store.getters.enabledShapes.filter((currentShape: string) => {
		return ( !props.disabledShapes.includes(currentShape) && currentShape !== "customized-currentShape" );
	});

	const categories = store.getters.getCategorizedShapes( enabledShapes );

	// Set order based on the order of the currentShape categories in php (ShapePresenter.php)
	return Object.keys(i18n.shapeCategories).reduce((acc, key) => {
		if (categories[key]) {
			acc[key] = categories[key];
		}
		return acc;
	}, {});
} );

function updateShape(currentShape: string) {
	store.commit( 'updatePresetShape', '' );

	if (props.storeShapeUpdater) {
		store.dispatch(props.storeShapeUpdater, currentShape);
	}
}

function setCategory(category: string) {
	type.value = category;
}

function editShape(): void {
	updateShape('');
}

function updatePreset(preset: AbstractPreset): void {
	store.dispatch('loadPresetConfig', preset);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!currentShape.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorizedShapes.value, (shapes, category) => {
                  return (_openBlock(), _createElementBlock("li", { key: category }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(['currentShape-type__button', type.value === category ? 'currentShape-type__button--active' : '']),
                      onClick: _withModifiers(($event: any) => (setCategory(category)), ["prevent"])
                    }, _toDisplayString(_unref(i18n).shapeCategories[category] ?? "Other"), 11, _hoisted_3)
                  ]))
                }), 128)),
                (!props.isCutout)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                      _createElementVNode("button", {
                        class: _normalizeClass(['currentShape-type__button', type.value === 'preset' ? 'currentShape-type__button--active' : '']),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setCategory('preset')), ["prevent"]))
                      }, _toDisplayString(_unref(i18n).shapeCategories['preset']), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(TextLabel, { class: "screen-reader-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).shapeCategories[type.value] ?? "Other"), 1)
                ]),
                _: 1
              }),
              (categorizedShapes.value[type.value])
                ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorizedShapes.value[type.value], (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, [
                        _createVNode(ButtonPrimitive, {
                          "on-click": () => updateShape(item),
                          icon: item,
                          class: _normalizeClass({
								'button--inactive': item !== '' && item !== currentShape.value,
							}),
                          "aria-label": _unref(i18n).shapeNames[item]
                        }, null, 8, ["on-click", "icon", "class", "aria-label"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (type.value === 'preset' && !_ctx.isCutout)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presets.value, (preset) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: preset.getName()
                      }, [
                        _createVNode(ButtonPrimitive, {
                          "on-click": () => updatePreset(preset),
                          icon: preset.getName(),
                          class: _normalizeClass({
								'button--inactive': preset.getName() !== '' && preset.getName() !== currentShape.value,
							}),
                          "aria-label": _unref(i18n).shapePresets[preset.getName()]
                        }, null, 8, ["on-click", "icon", "class", "aria-label"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (currentShape.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(EditableItem, {
                  icon: currentShape.value,
                  edit: { index: currentShape.value, title: _ctx.$i18n.cutout.edit, disabled: false, onClick: editShape, hidden: false },
                  remove: { index: currentShape.value, title: _ctx.$i18n.cutout.remove, disabled: false, onClick: editShape, hidden: false }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(shapeName.value), 1)
                  ]),
                  _: 1
                }, 8, ["icon", "edit", "remove"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})